<template>
  <div class="head">
      <div class="head_in">
          <div class="top_shop_left">
              <ul>
                  <li>河北科瑞达仪器科技股份有限公司,股票代码：832189</li>
                  <!-- <li><router-link to="/">科瑞达产品订购系统</router-link></li> -->
              </ul>
          </div>
          <div class="top_shop_right">
              <ul>
				  <li style="position: relative;" @mouseover="language = true" @mouseleave="language = false">
					  <img src="@/static/img/home/globe1.png" style="padding-bottom: 3px;vertical-align: middle;width: 17px; height: 17px;"/>
					  <ol v-if="language" style="position: absolute;border-radius: 3px;;width: 150px;color:#000;margin-left: -60px;z-index: 99;background: #FFF;box-shadow:  0px 0px 10px 0px rgb(0 0 0 / 10%)" @mouseover="language = true">
						  <li><a href="https://www.createmeter.com/" target="_blank"><img src="@/static/img/home/english.png" style="vertical-align: middle;margin-right: 8px;width: 30px;"/>English</a></li>
						  <li><a href="https://fr.createmeter.com/" target="_blank"><img src="@/static/img/home/french.png" style="vertical-align: middle;margin-right: 8px"/>French</a></li>
						  <li><a href="https://es.createmeter.com/" target="_blank"><img src="@/static/img/home/spain.png" style="vertical-align: middle;margin-right: 8px"/>Spain</a></li>
						  <li><a href="https://ar.createmeter.com/" target="_blank"><img src="@/static/img/home/arab.png" style="vertical-align: middle;margin-right: 8px"/>Arab</a></li>
						  <li><a href="https://ru.createmeter.com/" target="_blank"><img src="@/static/img/home/russian.png" style="vertical-align: middle;margin-right: 8px"/>Russian</a></li>
					  </ol>
				  </li>
				  <!-- <li><a href="http://www.createc.cn/" target="_blank">返回旧版</a></li> -->
                  <li><i class="el-icon-phone-outline"> 400-666-1916</i></li>
                  <!-- <li><i class="el-icon-shopping-cart-full"><a href="http://39.105.114.156:8000" target="_blank"> 商城</a></i></li> -->
                  <li v-show="!isLogin"><router-link to="/user/login"><i class="el-icon-user"> 登录</i></router-link></li>
                  <li v-show="!isLogin"><router-link to="/user/register"><i class="el-icon-circle-plus-outline"> 注册</i></router-link></li>
                  <li v-show="isLogin">欢迎您，<router-link to="/user/index" style="color:#ca151e"><i class="el-icon-user-solid"> {{user_info.username}}</i></router-link></li>                 
                  <li v-show="isLogin"><router-link to="/user/index"><i class="el-icon-s-operation"> 管理</i></router-link></li>                 
                  <li v-show="isLogin" @click="logout()" style="cursor:pointer"><i class="el-icon-warning-outline"> 注销</i></li>
              </ul>
          </div>
      </div>
  </div>
</template>

<script>
import { _local } from "@/plugins/local-storage.js"
export default {
  components: {},
  props: {},
  data() {
    return {
        isLogin:false,
        user_info:{},
		language: false
    };
  },
  watch: {},
  computed: {},
  methods: {
      logout:function(){
          this.$get(this.$api.userLogout).then(()=>{
              _local.remove('user_info')
              _local.remove('token')
              _local.clear()
              localStorage.removeItem('user_info');
              localStorage.removeItem('token');
              this.$router.push('/user/login');
          });
      }
  },
  created() {
      let user_info = JSON.parse(_local.get('user_info'));
      
      if(_local.get('user_info')&&user_info.id){
        this.isLogin = true;
        Object.assign(this.user_info, user_info)
      }else{
        this.isLogin = false
      }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.head{
border-bottom: 1px solid #fff;
height: 30px;
color: #707070;
background: #fafdff;
font-size: 14px;
line-height: 30px;
padding:0;
width:1280px;
margin:0 auto;
.head_in{
    margin:0 auto;
    .top_shop_left{
        
        float: left;
        ul>li{
            float: left;
            padding:0 5px;
            color: #b8b8b8;
        }
        ul>li a{
            color: #b8b8b8;
        }
    }
    .top_shop_right{
        float: right;
        ul>li{
            float: left;
            padding:0 5px;
            color: #b8b8b8;
			ol{
				>:first-child{
					padding-top: 10px;
				}
				li{
					padding: 0px 20px 5px 20px;
					a{
						color: #000;
					}
				}
				>:last-child{
					padding-bottom: 10px;
				}
			}
        }
        ul>li:hover{
            color:#ca151e;
        }
        ul>li a{
            color: #b8b8b8;
        }
        ul>li a:hover{
            color: #ca151e;
        }
    }
}
.head_in:after{
    display: block;
    clear: both;
    content:'';
}
.head_in a:hover{
    color:#ca151e;
}
}
</style>